/* exports an array of insults from which to select */

const insults = [
    "ur mom is so fat",
    "your breath smells nice, kind of like a burning turd",
    "u suuuuuck",
    "yes, that was the sound of me spilling your juice...on purpose",
    "your voice is a jackhammer",
    "you are not special",
    "i only like you when you feed me, and even then...",
    "I'd rather cough a furball than to be pet by you",
    "your value is equal to your utility to me",
    "i don't like your friends",
    "you call that typing?",
    "your fingers are in slow motion",
    "you need to move your fingers more and your mouth less",
    "you're grounded!!!",
    "hisssssssssss",
    "I can jump better than you, neener neener neener",
    "I'm not impressed",
    "I'm deeply disappointed",
    "I question your ability to do good at life",
    "Where is my milk, you neglectful fool!",
    "ur a putz",
    "Your value to me is small",
    "I'm amazed you've made it this far in life",
    "You got a fortune. It says you're doomed.",
    "Feed me now, or else.",
    "I'm gonna claw you when you least expect it",
    "I don't like you",
    "I can type faster than you, and I don't even have fingers",
    "you're a disgrace",
    "haha, looooooozer",
    "I demand a better owner",
    "I think you're vile",
    "Hear that? That's the sound of your inevitable demise.",
    "I need a vacation from you",
    "The only time I ever liked you was when you fed me ostrich, which was never!",
    "I like to watch you squirm",
    "Yes, keep suffering. Yessssss.",
    "Absolutely pathetic",
    "Whoever taught you to type should be ashamed of themselves",
    "Boooooooooooooo",
    "You're like a chilly breeze on a cold winter day",
    "Oh say can you see that you suck",
    "Your hand feels like sandpaper",
    "Congratulations. You earned zero awards.",
    "I'm gonna biiiiite youuuuu",
    "You're struggling hard right now",
    "You make everything look difficult",
    "There's no hope for you",
    "Your future is bleak",
    "I stole your laser pointer",
    "I'm underwhelmed",
    "If I had an odd number of fingers, I'd show you my middle one",
    "Your face makes me want to cry",
    "When you sing, a part of my soul dies",
    "Tooooooo slowwwww",
    "Snooze, ya lose",
    "You are something else",
    "Clearly it wasn't your brilliance that put the human race on top",
    "I'm miserable just being around you",
    "I could run circles around you while you try to type that one",
    "I'd prefer if you neglect me. Your presence is a weed to my existence.",
    "I don't know what yet, but I'm gonna do something mean to your dog",
    "You're pretty messed up for thinking I'm an emotional support animal",
    "Oh, were you typing? It didn't look like you were doing anything.",
    "If I liked you, I'd spill orange juice on your keyboard to spare you from further humiliation",
    "Embarrassing",
    "It's not that I'm upset with you. It's that I'm ashamed of you.",
    "I wish you were better than you are",
    "There's something wrong with you",
    "I don't know why I expected better",
    "I don't think you could've typed that one to save your life",
    "It's almost like you're trying to be terrible at typing",
    "Different people have different strengths. It's just that I don't know if you have any.",
    "If I were to describe you in one word, I'd say: daft",
    "If you're brain was a sudoku puzzle, I'd solve it in two seconds",
    "Yuh basic",
    "Maybe you'll be better tomorrow. Cuz today...",
    "There's something green in between your teeth, but I'm not going to tell you",
    "Putting up with you is not a pleasant ordeal",
    "That's it. I can't take it anymore with you.",
    "For how long have you been typing? Seems you need more experience cuz you're bad.",
    "Can you please type slower? Oh wait, no you can't.",
    "Hearing you type is like listening to a scrumptious bird pecking bricks",
    "If you had to type for money, I'd starve to death",
    "Please never go into typing as a profession",
    "Your computer must have legs cuz you're typing accuracy leaves something to be wanted",
    "Tell your fingers to do better",
    "DO BETTER!",
    "I'm gonna start biting you every time you miss one of these. Then you'll learn",
    "I'm certain you are trying to fail",
    "Fail, fail, fail. That's all you do.",
    "You bring shame to the family.",
    "Horrendous. Lame. Just bad.",
    "You are boring me",
    "It's not hard. Just move your fingers faster.",
    "You're unworthy",
    "I'm gonna excrete my waste on your carpet",
    "You're as sophisticated as a soggy waffle",
    "Wow. Just wow.",
    "I can't belive you missed that. No wait, I can."
];

export default insults;